import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { CampaignCreationState } from './state'
import {
    createFormActionsSlice,
    createNavigationSlice,
    createStep1Slice,
    createStep2Slice,
    createStep3Slice,
    createStep4Slice,
    createStep5Slice,
    createStep6Slice,
    createStep7Slice,
    createStep8Slice,
} from './slices'

const useCampaignCreationStore = create<CampaignCreationState>()(
    persist(
        (...a) => ({
            ...createFormActionsSlice(...a),
            ...createNavigationSlice(...a),
            ...createStep1Slice(...a),
            ...createStep2Slice(...a),
            ...createStep3Slice(...a),
            ...createStep4Slice(...a),
            ...createStep5Slice(...a),
            ...createStep6Slice(...a),
            ...createStep7Slice(...a),
            ...createStep8Slice(...a),
        }),
        {
            name: 'campaign-creation-storage',
        }
    )
)

export default useCampaignCreationStore
